export default {"src":"/_next/static/media/ec.b50a7672.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};